import { DatePipe } from '@angular/common'
import { Pipe, PipeTransform } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Pipe({
  name: 'localizedDate',
  standalone: true
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: Date | string, format = 'mediumDate'): string {
    const datePipe = new DatePipe(
      this.translateService.getCurrentLang() ?? 'en'
    )
    const formatted = datePipe.transform(value, format)
    return formatted != null ? formatted : ''
  }
}
